import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import app from './firebase';

const db = getFirestore(app);

export async function markNotificationAsClosed(
  collectionName: string,
  userId: number,
  notificationId: number
) {
  try {
    const docId = `user_${userId}`;
    const docRef = doc(db, collectionName, docId);

    // `merge: true` so each notification adds its own key. A plain setDoc REPLACES the whole
    // document, so closing one notification wiped every earlier one in the same collection —
    // and the scan-label intro flag, which now shares this document, would have been lost the
    // next time any notification in that collection was dismissed (IP-11131).
    await setDoc(
      docRef,
      {
        [notificationId]: true,
      },
      { merge: true }
    );
  } catch (e) {
    console.error('Error adding document: ', e);
  }
}

export async function getClosedNotifications(
  collectionName: string,
  userId: number
): Promise<number[]> {
  try {
    const docRef = doc(db, collectionName, `user_${userId}`);

    const docSnap = await getDoc(docRef);
    const closedNotifications: number[] = [];

    if (docSnap.exists()) {
      Object.entries(docSnap.data()).forEach(([key, _]) => {
        closedNotifications.push(Number(key));
      });

      return closedNotifications;
    } else {
      console.warn('No such document!');

      return closedNotifications;
    }
  } catch (e) {
    console.error('Error getting document:', e);
    return [];
  }
}
